import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContactModalComponent } from '../contact/contact-modal/contact-modal.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  public menuItems = [
    {
      name: "Home",
      link: "/"
    },
    {
      name: "About",
      link: "/about"
    },
    {
      name: "Clients",
      link: "/clients"
    },
    // {
    //   name: "Blogs",
    //   link: "/blogs"
    // },
    {
      name: "Services",
      link: "/services"
    }
  ]
  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  openContactModal() {
    this.dialog.open(ContactModalComponent, {  
      data: {},
      width: 'fit-content',
      height: 'fit-content',
      panelClass: 'contact-modal'
    });
  }
}
